export const firebaseConfig = {
  apiKey: "AIzaSyBryPVxrVnzihvTkfX-pg-wbaU8eF4BBf8", // process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: "cm-dev-22f6e.firebaseapp.com", //process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: "", // process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: "cm-dev-22f6e", // process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: "cm-dev-22f6e.firebasestorage.app", // process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: "12351476362", // process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: "1:12351476362:web:f443f0e35485b8c95ed373", // process.env.REACT_APP_FIREBASE_APPID,
};

export const environment = {
  local: {
    REDIRECT_URL: "http://localhost:3000",
    API_URL: "http://localhost:8080",
    GRAPH_BASE_URL: "https://graph.microsoft.com",
    GRAPH_VERSION: "v1.0",
    CLIENT_ID: "0c235339-a8d6-47ba-af64-6d68069f7baf",
    PERMISSION_SCOPES: [
      "profile",
      "user.read",
      "user.readbasic.all",
      "sites.read.all",
      "mail.read", // for the Outlook integration
      "team.readbasic.all", // for the Teams integration
      "teammember.read.all", // for the Teams integration
      "group.read.all", // for the Teams integration
      "channel.readbasic.all", // for the Teams integration
    ],
  },
  dev: {
    REDIRECT_URL: "https://dev.aicontractmanager.nl/auth/sign-in",
    API_URL: "https://gobeyond-be-dev.azurewebsites.net",
    GRAPH_BASE_URL: "https://graph.microsoft.com",
    GRAPH_VERSION: "v1.0",
    CLIENT_ID: "0c235339-a8d6-47ba-af64-6d68069f7baf",
    PERMISSION_SCOPES: [
      "profile",
      "user.read",
      "user.readbasic.all",
      "sites.read.all",
      "mail.read",
      "team.readbasic.all",
      "teammember.read.all",
      "group.read.all",
      "channel.readbasic.all", // for the Teams integration
    ],
  },
  demo: {
    REDIRECT_URL: "https://demo.aicontractmanager.nl/auth/sign-in",
    API_URL: "https://gobeyond-be-demo.azurewebsites.net",
    GRAPH_BASE_URL: "https://graph.microsoft.com",
    GRAPH_VERSION: "v1.0",
    CLIENT_ID: "0c235339-a8d6-47ba-af64-6d68069f7baf",
    PERMISSION_SCOPES: [
      "profile",
      "user.read",
      "user.readbasic.all",
      "sites.read.all",
      "mail.read",
      "team.readbasic.all",
      "teammember.read.all",
      "group.read.all",
      "channel.readbasic.all", // for the Teams integration
    ],
  },
  production: {
    REDIRECT_URL: "https://app.aicontractmanager.nl/auth/sign-in",
    API_URL: "https://gobeyond-be-prd.azurewebsites.net",
    GRAPH_BASE_URL: "https://graph.microsoft.com",
    GRAPH_VERSION: "v1.0",
    CLIENT_ID: "0c235339-a8d6-47ba-af64-6d68069f7baf",
    PERMISSION_SCOPES: [
      "profile",
      "user.read",
      "user.readbasic.all",
      "sites.read.all",
      "mail.read",
      "team.readbasic.all",
      "teammember.read.all",
      "group.read.all",
      "channel.readbasic.all", // for the Teams integration
    ],
  },
};
const env = process.env.REACT_APP_ENVIRONMENT || "local";
// const config = environment[process.env.NODE_ENV] || environment.local;
const config =
  environment[env as keyof typeof environment] || environment.local;
export default config;
